import {Amplify} from "aws-amplify";
import {AuthConfig} from "@aws-amplify/core";
import {cognitoOauthDomain, cognitoUserPoolId} from "../constants/defaultValues";

export const configureAmplify = (clientId: string) => {
  const authConfig: AuthConfig = {
    Cognito: {
      userPoolId: cognitoUserPoolId,
      userPoolClientId: clientId,
      loginWith: {
        username: true,
        email: true,
        oauth: {
          domain: cognitoOauthDomain,
          scopes: ["openid", "profile", "email"],
          redirectSignIn: [window.location.origin + "/"],
          redirectSignOut: [window.location.origin + "/"],
          responseType: "code",
        },
      },
    },
  };

  Amplify.configure({
    Auth: authConfig,
  });
};
